const config = {
  baseUrl: process.env.VUE_APP_BASE_URL,
  merchantUrl: process.env.VUE_APP_MERCHANT_URL,
  distributionUrl: process.env.VUE_APP_DISTRIBUTION_URL,
  fulfillmentUrl: process.env.VUE_APP_FULFILLMENT_URL,
  settlementUrl: process.env.VUE_APP_SETTLEMENT_URL,
  pimUrl: process.env.VUE_APP_PIM_URL,
};

export default config;
